<template>
  <section class="register-section d-flex align-items-center justify-content-center">
    <div class="card shadow p-4 register-card bg-white">
      <div class="text-center mb-4">
        <router-link to="/home">
          <img src="@/assets/images/logo2.png" alt="Logo" height="70" class="mb-2" />
        </router-link>
        <h4 class="fw-bold text-brand-yellow">Buzz Booking</h4>
        <h5 class="mt-2">Create your account</h5>
      </div>

      <form>
        <div class="mb-3">
          <label class="form-label text-dark">Full Name</label>
          <input type="text" class="form-control" placeholder="Enter your full name" />
        </div>

        <div class="mb-3">
          <label class="form-label text-dark">Email</label>
          <input type="email" class="form-control" placeholder="Enter your email" />
        </div>

        <div class="mb-3">
          <label class="form-label text-dark">Phone Number (Optional)</label>
          <input type="tel" class="form-control" placeholder="Enter your phone number" />
        </div>

        <div class="mb-3">
          <label class="form-label text-dark">Password</label>
          <input type="password" class="form-control" placeholder="Create a password" />
        </div>

        <div class="mb-3">
          <label class="form-label text-dark">Confirm Password</label>
          <input type="password" class="form-control" placeholder="Confirm your password" />
        </div>

        <div class="d-grid mt-4">
          <button type="submit" class="btn btn-brand-yellow text-white fw-semibold" @click="goToLogin">
            Create Account
          </button>
        </div>

        <div class="text-center mt-3">
          <router-link to="/login" class="back-login-link">
            Already have an account? Log in
          </router-link>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: "BuzzUserRegister",
  methods: {
    goToLogin() {
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.register-section {
  min-height: 100vh;
  background: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),
    url("@/assets/images/bg.jpg") center center / cover no-repeat;
  backdrop-filter: blur(2px);
  padding: 2rem;
}

.register-card {
  max-width: 450px;
  width: 100%;
  border-radius: 0.75rem;
}

.text-brand-yellow {
  color: #FFD700;
}

.btn-brand-yellow {
  background-color: #efcb01;
  border: none;
  transition: background-color 0.3s ease;
}

.btn-brand-yellow:hover {
  background-color: #dcbb00;
}

.back-login-link {
  color: #9db4ff;
  font-size: 0.95rem;
  text-decoration: none;
  transition: color 0.2s ease;
}

.back-login-link:hover {
  color: #909090;
  text-decoration: underline;
}
</style>
